/**
 * 動態讀取後端 base URL（沿用 js/index.js 的多環境判斷邏輯）
 */

// let api = `https://testface04.datailinc.com`
let api = `https://uniface01.datailinc.com`

export default api
